import { AccessPolicyMessageType } from '@playcastdotio/Messaging';

type ShareCodeResolvedCallback = (broadcastId: string, contract: unknown) => void;
type ShareCodeErrorCallback = (errorCode: string, errorMessage: string) => void;

let resolvedCallback: ShareCodeResolvedCallback | null = null;
let errorCallback: ShareCodeErrorCallback | null = null;

export function registerShareCodeCallbacks(
  onResolved: ShareCodeResolvedCallback,
  onError: ShareCodeErrorCallback,
): () => void {
  resolvedCallback = onResolved;
  errorCallback = onError;
  return () => {
    resolvedCallback = null;
    errorCallback = null;
  };
}

export const handleAccessPolicyMessage = (message: { type: string; [key: string]: unknown }): void => {
  switch (message.type) {
    case AccessPolicyMessageType.ACCESS_POLICY_RESOLVED: {
      const broadcastId = message.broadcastId as string;
      const contract = message.contract;
      console.log('[AccessPolicy] Share code resolved, broadcastId:', broadcastId);
      resolvedCallback?.(broadcastId, contract);
      break;
    }

    case AccessPolicyMessageType.ACCESS_POLICY_ERROR: {
      const error = message.error as { code: string; message: string } | undefined;
      console.error('[AccessPolicy] Error:', error?.code, error?.message);
      errorCallback?.(error?.code ?? 'UNKNOWN', error?.message ?? 'Unknown error');
      break;
    }

    default:
      break;
  }
};
